import { useState } from 'react'

import { useQueryClient } from '@tanstack/react-query'

import { useEventCapture } from '@surglogs-app/analytics'
import { useHandler } from '@surglogs-app/hooks'
import {
  getAccessManagementAccountQueryKey,
  useAuthManagementMfaSelfDisablePostMutation,
} from '@surglogs-app/network'
import { useToast } from '@surglogs-app/ui.toast'

import { useAccountSettingsTranslation } from '../services'

export const useMfaRevoke = () => {
  const { t } = useAccountSettingsTranslation()
  const { captureEvent } = useEventCapture()
  const queryClient = useQueryClient()
  const [isProcessingRevoke, setIsProcessingRevoke] = useState(false)
  const { mutateAsync: revokeSelfMfaMutateAsync } =
    useAuthManagementMfaSelfDisablePostMutation()
  const { showToast, showErrorToast } = useToast()

  const revokeMfaHandler = useHandler(async () => {
    try {
      setIsProcessingRevoke(true)
      await revokeSelfMfaMutateAsync(undefined)

      await queryClient.invalidateQueries({
        queryKey: getAccessManagementAccountQueryKey(),
      })

      showToast({
        title: t('mfaMethods.revokeSuccessful.title'),
        text: t('mfaMethods.revokeSuccessful.text'),
      })

      captureEvent('mfa_revoked', {
        context: 'account',
        variant: 'self',
        success: true,
      })
    } catch (error) {
      showErrorToast({ error })
      captureEvent('mfa_revoked', {
        context: 'account',
        variant: 'self',
        success: false,
      })
    } finally {
      setIsProcessingRevoke(false)
    }
  })

  return { revokeMfaHandler, isProcessingRevoke }
}
